import { ApolloError } from 'apollo-boost';
export function getGqlErrorMessage(error) {
    var _a, _b, _c;
    let errorText = 'Unknown error';
    if (typeof error === 'string') {
        errorText = error;
    }
    else if (error instanceof ApolloError) {
        errorText = (_c = (_b = (_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : error.message;
    }
    else if (error instanceof Error) {
        errorText = error.message;
    }
    return errorText;
}
